module.exports = __webpack_public_path__ + "img/rg.b6e1476d.png";